import {useReducer, useCallback, useMemo} from 'react';

function useAsync(f) {
  const [state, dispatch] = useReducer(
    (state, action) => {
      switch (action.type) {
        case 'LOADING':
          return {loading: true, error: false, result: null};
        case 'ERROR':
          return {loading: false, error: true, result: action.payload};
        case 'SUCCESS':
          return {loading: false, error: false, result: action.payload};
        default:
          return state;
      }
    },
    {
      loading: false,
      error: false,
      result: null
    }
  );

  const wrapper = useCallback(async (...args) => {
    dispatch({type: 'LOADING'});

    try {
      const payload = await f(...args);
      dispatch({type: 'SUCCESS', payload});
    }
    catch(payload) {
      dispatch({type: 'ERROR', payload});
    }
  }, [f, dispatch]);

  return useMemo(() => [wrapper, state], [wrapper, state]);
}

export default useAsync;